import React from 'react';
import PropTypes from 'prop-types';

class PackageList extends React.PureComponent {

    render() {

        const {packages} = this.props;

        if (!packages || packages.count() === 0) {
            return null;
        }

        const groupedPackages = packages
            .groupBy(item => item.get('type'))
            .toList();

        const groupItems = (item) => {
                return item
                .groupBy(g => g.get('id'))
                .toList();
        };       

        const getRows = (section) => {

            return groupItems(section).map((groupedItem, index) => {

                return (
                    <tr key={'package_' + index}>
                        <td>{groupedItem
                                .first()
                                .get('id')}
                        </td>
                        <td>{groupedItem.count()}</td>
                        <td>{groupedItem
                                .first()
                                .get('name')}</td>                        
                    </tr>
                    
                );
            });

        };

        const sections = groupedPackages.map((item, index) => {
            return (

                <div key={'packageSection_' + index}>
                    <h5>{item
                            .first()
                            .get('type')}</h5>
                    <table className="bordered striped">
                        <thead>
                            <tr>
                                <th>Id</th>
                                <th>Qty</th>
                                <th>Description</th>
                            </tr>
                        </thead>
                        <tbody>{getRows(item)}</tbody>
                    </table>
                </div>

            );
        });

        return (
            <div>
                {sections}
            </div>
        );
    }
}
PackageList.propTypes = {
    packages: PropTypes.object

};
export default PackageList;



// WEBPACK FOOTER //
// ./src/components/account/PackageList.js